export const Arr_NonFoodAllergiesInfo = [
  //-------------------------------------------------------------------------
  //start NonFoodAllergies_insect_allergies
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Insect allergies",
    name: "NonFoodAllergies_insect_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "FoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what the allergy is?",
    name: "NonFoodAllergies_insect_allergies_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "NonFoodAllergies_insect_allergies_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies",
  },

  //Prescition should go here

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_insect_allergies_otc_medicine",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine, such as an antihistamine, to alleviate any symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "NonFoodAllergies_insect_allergies_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_insect_allergies_anything_else_specified",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_anything_else",
  },

  //next part
  //NonFoodAllergies_insect_allergies_
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "NonFoodAllergies_insect_allergies_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies",
    AboveText: (
      <p>
        Please tell us if the student requires life-saving or reactive
        medication if they interact with the allergen
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "NonFoodAllergies_insect_allergies_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "NonFoodAllergies_insect_allergies_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_insect_allergies_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_insect_allergies_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Medication SubSection
  //concat(getFullMedicationArray(Page, name))
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_insect_allergies_prescribed_medication_interact_badly",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_insect_allergies_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_insect_allergies_prescribed_medication_storage_requirements",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_insect_allergies_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_insect_allergies_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_insect_allergies_prescribed_medication_anything_else",
  },
  //end NonFoodAllergies_insect_allergies

  //start NonFoodAllergies_latex_allergies
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Latex allergies",
    name: "NonFoodAllergies_latex_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "NonFoodAllergies_latex_allergies_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies",
  },

  //Prescition should go here

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_latex_allergies_otc_medicine",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine, such as an antihistamine, to alleviate any symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "NonFoodAllergies_latex_allergies_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_latex_allergies_anything_else_specified",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_anything_else",
  },

  //next part
  //NonFoodAllergies_latex_allergies_
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "NonFoodAllergies_latex_allergies_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies",
    AboveText: (
      <p>
        Please tell us if the student requires life-saving or reactive
        medication if they interact with the allergen
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "NonFoodAllergies_latex_allergies_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "NonFoodAllergies_latex_allergies_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_latex_allergies_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_latex_allergies_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Medication SubSection
  //concat(getFullMedicationArray(Page, name))
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_latex_allergies_prescribed_medication_interact_badly",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_latex_allergies_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_latex_allergies_prescribed_medication_storage_requirements",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_latex_allergies_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_latex_allergies_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_latex_allergies_prescribed_medication_anything_else",
  },
  //end NonFoodAllergies_latex_allergies

  //start NonFoodAllergies_medication_allergies
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication allergies",
    name: "NonFoodAllergies_medication_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "FoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what the allergy is?",
    name: "NonFoodAllergies_medication_allergies_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "NonFoodAllergies_medication_allergies_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies",
  },

  //Prescition should go here

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_medication_allergies_otc_medicine",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine, such as an antihistamine, to alleviate any symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "NonFoodAllergies_medication_allergies_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_medication_allergies_anything_else_specified",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_anything_else",
  },

  //next part
  //NonFoodAllergies_medication_allergies_
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "NonFoodAllergies_medication_allergies_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies",
    AboveText: (
      <p>
        Please tell us if the student requires life-saving or reactive
        medication if they interact with the allergen
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "NonFoodAllergies_medication_allergies_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "NonFoodAllergies_medication_allergies_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_medication_allergies_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_medication_allergies_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Medication SubSection
  //concat(getFullMedicationArray(Page, name))
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_medication_allergies_prescribed_medication_interact_badly",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_medication_allergies_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_medication_allergies_prescribed_medication_storage_requirements",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_medication_allergies_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_medication_allergies_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_medication_allergies_prescribed_medication_anything_else",
  },
  //end NonFoodAllergies_medication_allergies

  //start NonFoodAllergies_seasonal_allergies
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student experience seasonal allergies (e.g. ragweed or pollen)",
    name: "NonFoodAllergies_seasonal_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "FoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what the allergy is?",
    name: "NonFoodAllergies_seasonal_allergies_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "NonFoodAllergies_seasonal_allergies_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies",
  },

  //Prescition should go here

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_seasonal_allergies_otc_medicine",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine, such as an antihistamine, to alleviate any symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "NonFoodAllergies_seasonal_allergies_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_seasonal_allergies_anything_else_specified",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_anything_else",
  },

  //next part
  //NonFoodAllergies_seasonal_allergies_
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "NonFoodAllergies_seasonal_allergies_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies",
    AboveText: (
      <p>
        Please tell us if the student requires life-saving or reactive
        medication if they interact with the allergen
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "NonFoodAllergies_seasonal_allergies_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "NonFoodAllergies_seasonal_allergies_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_seasonal_allergies_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_seasonal_allergies_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Medication SubSection
  //concat(getFullMedicationArray(Page, name))
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_seasonal_allergies_prescribed_medication_interact_badly",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_seasonal_allergies_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_seasonal_allergies_prescribed_medication_storage_requirements",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_seasonal_allergies_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_seasonal_allergies_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_seasonal_allergies_prescribed_medication_anything_else",
  },
  //end NonFoodAllergies_seasonal_allergies

  //start NonFoodAllergies_other_non_food_allergies
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Other allergies",
    name: "NonFoodAllergies_other_non_food_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "FoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what the allergy is?",
    name: "NonFoodAllergies_other_non_food_allergies_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "NonFoodAllergies_other_non_food_allergies_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies",
  },

  //Prescition should go here

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_other_non_food_allergies_otc_medicine",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine, such as an antihistamine, to alleviate any symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "NonFoodAllergies_other_non_food_allergies_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_non_food_allergies_anything_else_specified",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_anything_else",
  },

  //next part
  //NonFoodAllergies_other_non_food_allergies_
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "NonFoodAllergies_other_non_food_allergies_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies",
    AboveText: (
      <p>
        Please tell us if the student requires life-saving or reactive
        medication if they interact with the allergen
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "NonFoodAllergies_other_non_food_allergies_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "NonFoodAllergies_other_non_food_allergies_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_other_non_food_allergies_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_other_non_food_allergies_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Medication SubSection
  //concat(getFullMedicationArray(Page, name))
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_non_food_allergies_prescribed_medication_interact_badly",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_non_food_allergies_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_non_food_allergies_prescribed_medication_storage_requirements",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_non_food_allergies_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_non_food_allergies_prescribed_medication_anything_else",
  },

  //end NonFoodAllergies_other_non_food_allergies

  //start NonFoodAllergies_other_2_non_food_allergies
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Other allergies",
    name: "NonFoodAllergies_other_2_non_food_allergies",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_non_food_allergies",
    AboveText: <h2>Any Other Additional Non-food Allergies</h2>,
  },
  {
    Page: "FoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what the allergy is?",
    name: "NonFoodAllergies_other_2_non_food_allergies_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Please tell us the severity of the allergy if triggered",
    name: "NonFoodAllergies_other_2_non_food_allergies_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_other_2_non_food_allergies_otc_medicine",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine, such as an antihistamine, to alleviate any symptoms above as a
        result
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "NonFoodAllergies_other_2_non_food_allergies_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about this
        allergy
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_2_non_food_allergies_anything_else_specified",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_anything_else",
  },

  //next part
  //NonFoodAllergies_other_2_non_food_allergies_
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Prescription",
    name: "NonFoodAllergies_other_2_non_food_allergies_medication",
    selectValues: [
      "EpiPen, (an epinephrine autoinjector)",
      "Other lifesaving medication",
      "Prescribed medication (not lifesaving)",
      "No, the student does not have any prescribed medication for this allergy",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies",
    AboveText: (
      <p>
        Please tell us if the student requires life-saving or reactive
        medication if they interact with the allergen
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "EpiPen brand name",
    name: "NonFoodAllergies_other_2_non_food_allergies_epipen_brand_name",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: <p>Please specify the EpiPen brand name</p>,
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage",
    name: "NonFoodAllergies_other_2_non_food_allergies_epipen_dosage",
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        What is the dosage in the EpiPen for the student? (e.g. 200mg/ 100mg)
      </p>
    ),
  },
  //NEW EpiPen
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_other_2_non_food_allergies_epipen_bringing",
    selectValues: ["Yes, the student will always carry their EpiPen"],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        Ensure the EpiPen is in date, and confirm below that the student will
        carry it with them at all times.
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Carrying EpiPen",
    name: "NonFoodAllergies_other_2_non_food_allergies_epipen_bringing_spare",
    selectValues: [
      "Yes, the student will bring a spare EpiPen",
      "The student is unable to bring a spare EpiPen",
    ],
    onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        InvestIN strongly recommends that the student brings a spare EpiPen with
        them, please confirm if this is possible.
      </p>
    ),
  },
  //END EpiPen

  //Medication SubSection
  //concat(getFullMedicationArray(Page, name))
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_dosage",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_frequency",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_application",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. use EpiPen in thigh)",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_instructions",
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_interact_badly",
  },

  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other lifesaving medication"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_storage_requirements",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Prescribed medication (not lifesaving)",
      "Other lifesaving medication",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_other_2_non_food_allergies_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "NonFoodAllergies_other_2_non_food_allergies_prescribed_medication_anything_else",
  },
  //end NonFoodAllergies_other_2_non_food_allergies
  //
  //
  //
  //
  //
  //
  //Other random question aka travel sickness
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student experience travel sickness",
    name: "NonFoodAllergies_travel_sickness",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Triggers",
    name: "NonFoodAllergies_travel_sickness_triggers",
    selectValues: [
      {
        name: "NonFoodAllergies_travel_sickness_triggers_bus_coach",
        label: "Bus/ coach",
      },
      {
        name: "NonFoodAllergies_travel_sickness_triggers_car_taxi",
        label: "Car/ taxi",
      },
      {
        name: "NonFoodAllergies_travel_sickness_triggers_train",
        label: "Train",
      },
      {
        name: "NonFoodAllergies_travel_sickness_triggers_aeroplane",
        label: "Aeroplane",
      },
      {
        name: "NonFoodAllergies_travel_sickness_triggers_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If yes, please indicate which forms of motion trigger travel sickness,
        and select all that apply
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_travel_sickness_triggers_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness_triggers_other",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How severe is their travel sickness",
    name: "NonFoodAllergies_travel_sickness_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student likely to vomit from their travel sickness",
    name: "NonFoodAllergies_travel_sickness_vomit",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "NonFoodAllergies_travel_sickness_help",
    selectValues: [
      {
        name: "NonFoodAllergies_travel_sickness_help_sitting_front",
        label: "Sitting near the front of the vehicle (e.g. coach)",
      },
      {
        name: "NonFoodAllergies_travel_sickness_help_sitting_window",
        label: "Sitting next to a window",
      },
      {
        name: "NonFoodAllergies_travel_sickness_help_otc_prior",
        label:
          "Taking over-the-counter travel sickness tablets prior to travelling",
      },
      {
        name: "NonFoodAllergies_travel_sickness_help_sickness_aids",
        label:
          "Use of other anti-motion sickness aids (such as wrist bands, motion sickness glasses) please note, InvestIN will only have OTC anti sickness medications available, any other anti-motion sickness aids will need to be brought by the student",
      },
      {
        name: "NonFoodAllergies_travel_sickness_help_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student needs to use transportation during the programme (e.g. to
        travel to/ from programmes or activities, or to attend the summer
        experience). What would help the student to feel better during this time
      </p>
    ),
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "NonFoodAllergies_travel_sickness_help_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness_help_other",
  },
  {
    Page: "NonFoodAllergiesInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter medicine",
    name: "NonFoodAllergies_travel_sickness_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "NonFoodAllergies_travel_sickness",
    AboveText: (
      <p>
        If required, could the student be provided with an over-the-counter
        medicine to alleviate any symptoms above as a result
      </p>
    ),
  },
];
